<!--
 * @Author: yuhaiqin@wps.cn
 * @Description: 通用弹窗 ui
-->
<template>
  <el-dialog
    v-model="visible"
    :width="width"
    customClass="dialog-common ui-dialog"
    appendToBody
    :showClose="false"
    :closeOnClickModal="false"
  >
    <div class="header">
      <div class="header-title">
        <slot name="title">
          <span>{{ title }}</span>
        </slot>
      </div>
      <IconMyIconClose class="header-close" @click="onClose"></IconMyIconClose>
    </div>
    <div class="body">
      <slot />
    </div>
    <div class="footer">
      <slot name="footer" />
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '标题',
  },
  width: {
    type: Number,
    default: 420,
  },
});
const visible = ref(false);
const onClose = () => {
  visible.value = false;
};

// v-model 响应式处理
const emit = defineEmits(['update:modelValue']);
watch(visible, (val) => {
  emit('update:modelValue', val);
});
watch(
  () => props.modelValue,
  (val) => {
    visible.value = val;
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  padding: 18px 24px 0;
  &-title {
    flex: 1;
    font-size: 20px;
    font-family: MicrosoftYaHei;
    color: var(--lowcode-text-01);
    display: flex;
    align-items: center;
  }
  &-close {
    cursor: pointer;
  }
}
.body {
  padding: 12px 24px 24px;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px 24px;
}
</style>

<style lang="scss">
.ui-dialog {
  .el-dialog__header,
  .el-dialog__body {
    padding: 0;
    margin: 0;
  }
}
</style>
